module.exports = __webpack_public_path__ + "img/1506460601.bf6b74ce.jpg";